import { PageTitle } from '@doda/io-react/pc';
import { AgentService } from 'components/AgentService';
import { useInitializeOnClient } from '../../hooks/useInitializeOnClient';
import { PageImpression } from '../../components/PageImpression';
import { Meta } from '../../components/Meta';
import {
  Content,
  PageLayout,
  MainSection,
  SideSection,
} from '../../components/Layout';
import { Breadcrumb } from '../../components/Breadcrumb';
import type { SideBarProps } from '../../components/SearchSideBar/types';
import { SearchSideBar } from '../../components/SearchSideBar';
import { DesiredCondSetting } from '../../components/DesiredCondSetting';
import { RecommendLink } from '../../components/RecommendLink';
import { ListControls } from '../../components/ListControls';
import { JobList } from '../../components/JobList';
import { Pagination } from '../../components/Pagination';
import { RecommendSection } from '../../components/RecommendSection';
import styles from './index.module.scss';

const AGENT_SERVICE_LINK =
  '/dcfront/member/memberRegist/?entry_id=1&carry_id=5100002287&carry_class=k';

/**
 *  希望条件にマッチした求人一覧のProps
 */
export interface MatchJobListScreenProps {
  /** エージェントサービスを表示するかどうか */
  showAgentService: boolean;
  /** ページネーションを表示するかどうか */
  showPagination: boolean;
  /** サイドバーのプロパティ */
  sideBarProps: SideBarProps;
}

/**
 * 希望条件にマッチした求人一覧画面
 *
 * @param {MatchJobListScreenProps} props - コンポーネントのプロパティ
 * @param {boolean} props.showAgentService - エージェントサービスを表示するかどうか
 * @param {boolean} props.showPagination - ページネーションを表示するかどうか
 * @param {SideBarProps} props.sideBarProps - サイドバーのプロパティ
 * @param {SeoFooterLinkProps['data']} props.seoFooterLink - SEOフッターリンクのデータ
 * @returns {JSX.Element} - 求人一覧画面コンポーネント
 */
export const MatchJobListScreen = ({
  showAgentService,
  showPagination,
  sideBarProps,
}: MatchJobListScreenProps) => {
  useInitializeOnClient();
  return (
    <>
      <PageImpression />
      <Meta />
      <PageLayout>
        <Breadcrumb />
        <Content>
          <SideSection>
            <SearchSideBar sideBarProps={sideBarProps} />
          </SideSection>
          <MainSection>
            <PageTitle className={styles['matchJobList-heading']}>
              希望条件にマッチした求人一覧
            </PageTitle>
            <div className={styles['matchJobList-layout__jobSearch']}>
              <DesiredCondSetting />
              <RecommendLink />
              <ListControls />
              <JobList />
            </div>
            {showPagination && (
              <div className={styles['matchJobList-layout__pagination']}>
                <Pagination />
              </div>
            )}
            <div className={styles['matchJobList-layout__bottom-section']}>
              <RecommendSection />
              {showAgentService && <AgentService href={AGENT_SERVICE_LINK} />}
            </div>
          </MainSection>
        </Content>
      </PageLayout>
    </>
  );
};
